var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('div',{class:{ 'cont-title': true, none: !_vm.subtitle }},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"cont-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }